<template>
    <div class="field-row">
        <label class="input-title">{{ $t('contracts.select_contract') }}</label>
        <multiselect
            v-model="selectedContract"
            :options="contracts"
            :close-on-select="true"
            label="name"
            track-by="id"
            :searchable="true"
            :internal-search="true"
            :selected-label="$t('common.selected')"
            :select-label="$t('common.select')"
            :deselect-label="$t('common.remove_selection')"
            :placeholder="$t('orders.select_contract')"
            :disabled="loading > 0"
            :loading="loading > 0"
        >
            <template #singleLabel="{ option }">
                <span>{{ option.customer.name }} - {{ option.name }}</span>
            </template>
            <template #option="{ option }">
                <div>{{ option.customer.name }} - {{ option.name }}</div>
            </template>
            <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
            </template>
            <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
            </template>
        </multiselect>
    </div>
</template>

<script>
import { restApi } from '../mixins/RestApiMixin'
import { timeUtils } from '../mixins/TimeUtils'

export default {
    name: 'RouteOptimizationContractSelector',
    mixins: [restApi, timeUtils],
    props: {
        from: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: true
        },
        modelValue: {
            type: Object,
            default: null
        }
    },
    emits: ['contract-selected', 'loading', 'contracts-loaded', 'update:modelValue'],
    data() {
        return {
            contracts: [],
            selectedContract: null,
            loading: 0
        }
    },
    watch: {
        from() {
            this.fetchContracts()
        },
        to() {
            this.fetchContracts()
        },
        selectedContract(contract) {
            this.$emit('contract-selected', contract)
            this.$emit('update:modelValue', contract)
        },
        modelValue(newVal) {
            if (newVal !== this.selectedContract) {
                this.selectedContract = newVal
            }
        },
        loading(isLoading) {
            this.$emit('loading', isLoading > 0)
        }
    },
    mounted() {
        if (this.modelValue) {
            this.selectedContract = this.modelValue
        }
        this.fetchContracts()
    },
    methods: {
        fetchContracts() {
            if (!this.from) return

            this.loading++
            const params = {
                startDate: this.localTimeToUtcTime(this.from).toISOString(),
                endDate: this.to ? this.getEndOfTheDay(this.to).toISOString() : null
            }

            this.restFetchParams(this.contractOpenUrl, params, this.handleContracts)
        },
        handleContracts(response) {
            this.loading--
            if (response && response.data) {
                this.contracts = response.data
                this.$emit('contracts-loaded', response.data)
            }
        }
    }
}
</script>

<style scoped>
.input-title {
    font-size: .9em;
    color: #404041;
}


:deep(.multiselect__spinner) {
    width: 40px;
    height: 28px;
    background: #fff;
    right: 1px;
    top: 1px;
}

.invalid :deep(.multiselect__tags) {
    border-color: #dc3545;
}
</style>
